import React from "react";
import "./spinner.css";

export const Spinner = ({ clases }) => {
  return (
    <div className="lds-vt">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export const SpinnerCircle = ({ clases }) => {
  return <div className={`lds-ring ${clases}`}></div>;
};
export const SpinnerCircleMini = ({ clases }) => {
  return <div className={`lds-ring-mini ${clases}`}></div>;
};
